export default __webpack_public_path__ + "7cd340be058a8393c3d6719cda8f767b.png";